import React, { useState } from 'react'
import { Card } from '../Card'
import { Container } from '../Container'
import { TextInput } from '../TextInput'
import { Button } from '../Button'
import { H1, Text } from '../Typography'
import { Page } from '../Page'
import { Center } from '../Center'
import defaultLogo from '../../assets/ICONA-S.svg'

export const LoginElement = ({
  logo = defaultLogo,
  title = "Welcome",
  subtitle = "Sign in to access your account",
  emailLabel = "Email Address",
  emailPlaceholder = "Enter your email",
  passwordLabel = "Password",
  passwordPlaceholder = "Enter your password",
  buttonText = "Sign In",
  loadingText = "Signing in...",
  footerText,
  onSubmit,
  isLoading = false,
  error,
  forgotPasswordText,
  onForgotPassword,
  magicLinkText,
  onMagicLink
}) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (onSubmit) {
      onSubmit(email, password)
    }
  }

  return (
    <Page style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: 0 }}>
      <Card style={{ width: '100%', maxWidth: '800px', padding: '40px', borderRadius: '24px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' }}>
        <form onSubmit={handleSubmit}>
          <Container direction="vertical" gap={32}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {logo && (
                <div style={{ marginBottom: '24px' }}>
                  <img src={logo} alt="Logo" style={{ height: '150px', display: 'block' }} />
                </div>
              )}
              <div style={{ marginBottom: '8px' }}>
                <H1 style={{ fontSize: '28px', textAlign: 'center', color: '#1e293b', margin: 0 }}>{title}</H1>
              </div>
              <div>
                <Text style={{ color: '#64748b', textAlign: 'center', fontSize: '16px', margin: 0 }}>{subtitle}</Text>
              </div>
            </div>

            {error && (
              <div style={{ padding: '16px', background: '#fee2e2', borderRadius: '12px', border: '1px solid #fecaca' }}>
                <Text style={{ color: '#ef4444', textAlign: 'center', fontSize: '14px' }}>{error}</Text>
              </div>
            )}

            <Container direction="vertical" gap={20}>
              <TextInput 
                label={emailLabel} 
                name="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                placeholder={emailPlaceholder}
                required
                style={{ width: '100%' }}
              />
              <TextInput 
                label={passwordLabel} 
                name="password" 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)}
                placeholder={passwordPlaceholder}
                required
                style={{ width: '100%' }}
              />
            </Container>

            <Button type="submit" size="lg" fullWidth disabled={isLoading} style={{ marginTop: '8px', height: '48px', fontSize: '16px' }}>
              {isLoading ? loadingText : buttonText}
            </Button>

            {(forgotPasswordText || magicLinkText) && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: '24px' }}>
                {forgotPasswordText && (
                  <span
                    onClick={onForgotPassword}
                    style={{ color: '#64748b', fontSize: '14px', cursor: 'pointer' }}
                  >
                    {forgotPasswordText}
                  </span>
                )}
                {magicLinkText && (
                  <span
                    onClick={onMagicLink}
                    style={{ color: '#64748b', fontSize: '14px', cursor: 'pointer' }}
                  >
                    {magicLinkText}
                  </span>
                )}
              </div>
            )}

            {footerText && (
              <Center>
                <Text style={{ fontSize: '14px', color: '#94a3b8' }}>
                  {footerText}
                </Text>
              </Center>
            )}
          </Container>
        </form>
      </Card>
    </Page>
  )
}
